import { Table } from "antd";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import { getAssets } from "../../redux/rtk/features/assets/assetsSlice";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";
import ColVisibilityDropdown from "../Shared/ColVisibilityDropdown";
import { CsvLinkBtn } from "../UI/CsvLinkBtn";
import AssignAssetPopup from "../UI/PopUp/assignAssetPopup";
import ReturnAssetPopup from "../UI/PopUp/returnAssetsPopup";

function CustomTable({ list, total }) {
	const dispatch = useDispatch();
	const [columnsToShow, setColumnsToShow] = useState([]);
	const [selectedAsset, setSelectedAsset] = useState(null);
	const [isPopupOpen, setIsPopupOpen] = useState(false);

	const handleAssignAsset = (record) => {
		console.log("Assigning asset:", record);
		setSelectedAsset(record);
		setIsPopupOpen(true);
	};

	const handleClosePopup = () => {
		setIsPopupOpen(false);
		setSelectedAsset(null);
	};
	console.log(list);

	const columns = [
		{
			title: "S.No",
			dataIndex: "serial",
			key: "serial",
		},
		{
			title: "Asset Type",
			key: "assetsTypeName",
			render: (record) =>
			  record.assets && record.assets.assetstype
				? record.assets.assetstype.assetsTypeName
				: "N/A", // Fallback text if any property is missing
		  },
		{
			title: "Asset Name",
			dataIndex: "assetName",
			key: "assetName",
		},
		{
			title: "Asset Code 1 Name",
			dataIndex: "assetCode1Name",
			key: "assetCode1Name",
		},
		{
			title: "Asset Code 1",
			dataIndex: "assetCode1",
			key: "assetCode1",
		},
		{
			title: "Asset Code 2 Name",
			dataIndex: "assetCode2Name",
			key: "assetCode2Name",
		},
		{
			title: "Asset Code 2",
			dataIndex: "assetCode2",
			key: "assetCode2",
		},
		{
			title: "Asset Cost",
			dataIndex: "assetCost",
			key: "assetCost",
			render: (cost) => `₹${cost}`,
		},
		{
			title: "Action",
			key: "action",
			render: (_, record) => (
				<div className="flex gap-2">
					<AssignAssetPopup assetData={record} />
					<ReturnAssetPopup assetData={record} />
				</div>
			),
		}
	];

	useEffect(() => {
		setColumnsToShow(columns);
	}, []);

	const columnsToShowHandler = (val) => {
		setColumnsToShow(val);
	};

	const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

	return (
		<div className='ant-card p-4 rounded mt-5'>
			<div className='flex my-2 justify-between'>
				<div className='w-50'>
					<h4 className='text-2xl mb-2'> Assets Forms</h4>
				</div>
				{list && (
					<div className='flex justify-end mr-4'>
						<div className='mt-0.5'>
							<CsvLinkBtn>
								<CSVLink
									data={list}
									className='btn btn-dark btn-sm'
									style={{ marginTop: "5px" }}
									filename='expense_forms'>
									Download CSV
								</CSVLink>
							</CsvLinkBtn>
						</div>
					</div>
				)}
			</div>
			{list && (
				<div style={{ marginBottom: "30px" }}>
					<ColVisibilityDropdown
						options={columns}
						columns={columns}
						columnsToShowHandler={columnsToShowHandler}
					/>
				</div>
			)}
			<Table
				className='text-center'
				scroll={{ x: true }}
				loading={!list}
				pagination={{
					defaultPageSize: 20,
					pageSizeOptions: [10, 20, 50, 100, 200],
					showSizeChanger: true,
					total: total ? total : 100,

				}}
				columns={columnsToShow}
				dataSource={list ? addKeys(list) : []}
			/>
			{list && list.length === 0 && <div></div>}
			{selectedAsset && (
				<AssignAssetPopup
					open={isPopupOpen}
					onClose={handleClosePopup}
					assetData={selectedAsset}
				/>
			)}
		</div>
	);
}

const AssetsStatus = (props) => {
	const dispatch = useDispatch();
	const list = useSelector((state) => state.asset.list);
	const total = useSelector((state) => state.asset.total);

	useEffect(() => {
		dispatch(getAssets());
	}, [dispatch]);

	return (
		<UserPrivateComponent permission={"readAll-leaveApplication"}>
			<div className='card card-custom'>
				<div className='card-body'>
					<CustomTable list={list} total={total} />
				</div>
			</div>
		</UserPrivateComponent>
	);
};

export default AssetsStatus;
